import { Box, Button, Flex, Spinner, Text, Textarea } from "@chakra-ui/react";

const AddNoteModalContent = ({
  newNoteText,
  setNewNoteText,
  handleAddNote,
  isNewNoteAdding,
}) => {
  return (
    <Box>
      <Text fontSize="lg" mb={2} fontWeight="bold">
        Add New Note
      </Text>
      <Textarea
        rows={5}
        value={newNoteText}
        onChange={(e) => setNewNoteText(e.target.value)}
        placeholder="Write your note here..."
      />
      <Flex justifyContent="flex-end" mt={4}>
        <Button
          variant="primary"
          onClick={handleAddNote}
          isDisabled={!newNoteText.trim() || isNewNoteAdding}
          loadingText="Saving...."
          isLoading={isNewNoteAdding}
          spinner={<Spinner size="sm" />}
          _disabled={{ color: "white", bg: "bgColor" }}
          _hover={{ bg: "bgColor", color: "white" }}
        >
          Save
        </Button>
      </Flex>
    </Box>
  );
};

export default AddNoteModalContent;
